<template>
  <v-list>
    <v-list-group no-action prepend-icon="fas fa-tools">
      <template v-slot:activator>
        <v-list-item-title>{{
          $t("global.menu.configurations")
        }}</v-list-item-title>
      </template>
      <v-list-item
        v-if="$checkFunctionality('COUNTRIES')"
        link
        :to="{ name: 'countries' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-globe-europe</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.countries")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('AGENCIES')"
        link
        :to="{ name: 'agencies' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-warehouse</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.agencies")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('PROFILES')"
        link
        :to="{ name: 'profiles' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-id-card</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.profiles")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('USERS')"
        link
        :to="{ name: 'users' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-user-alt</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("global.menu.users") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('ROUTES')"
        link
        :to="{ name: 'routes' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-route</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("global.menu.routes") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('ZONES')"
        link
        :to="{ name: 'zones' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-layer-group</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("global.menu.zones") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('POSTALCODES')"
        link
        :to="{ name: 'postalCodes' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-mail-bulk</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.postalCodes")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('HOLIDAYS')"
        link
        :to="{ name: 'holidays' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-calendar-times</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.holidays")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('SERVICES')"
        link
        :to="{ name: 'services' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-truck-loading</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.services")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('AGENCYPARAMETERS')"
        link
        :to="{ name: 'agencyParameters' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-boxes</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("global.menu.agencyParameters") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('CLIENTS')"
        link
        :to="{ name: 'clients' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-users</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("global.menu.clients") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('TIMESLOTS')"
        link
        :to="{ name: 'timeSlots' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-business-time</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.timeSlots")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$checkFunctionality('PRODUCTSTYPES')"
        link
        :to="{ name: 'productsTypes' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-boxes</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.productsTypes")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
    <v-list>
      <v-list-item
        v-if="$checkFunctionality('TIMESLOTS')"
        link
        :to="{ name: 'statistics' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-chart-area</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.statistics")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list>
      <v-list-item
        v-if="$checkFunctionality('AUDIT')"
        link
        :to="{ name: 'audit' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-audio-description</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("global.menu.audit") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list>
      <v-list-item
        v-if="$checkFunctionality('TIMESLOTSRESERVATIONS')"
        link
        :to="{ name: 'timeSlotsReservations' }"
      >
        <v-list-item-icon>
          <v-icon>fas fa-calendar-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.timeSlotsReservations")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-list>
</template>

<script>
export default {
  name: "Menu"
};
</script>
